import { z } from 'zod';
/**
 * Stable, machine-readable error codes. The frontend maps a code to a
 * translated message; it never parses the human-readable `message`.
 * Add codes, never repurpose them.
 */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'USERNAME_TAKEN',
    'NO_PLATFORM_ACCESS',
    'UA_UNAVAILABLE',
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UNIQUE_VIOLATION',
    'FOREIGN_KEY_VIOLATION',
    'RATE_LIMITED',
    'IDEMPOTENCY_KEY_REUSED',
    'REQUEST_IN_PROGRESS',
    'PAYLOAD_TOO_LARGE',
    'UNPROCESSABLE',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    // whatsapp.md section 2 and 5: the platform and admin APIs.
    'TEMPLATE_NOT_FOUND',
    'TEMPLATE_EXISTS',
    'SYSTEM_EXISTS',
    'MESSAGE_NOT_RETRYABLE',
    'IDEMPOTENCY_CONFLICT',
    'VERIFICATION_SEND_FAILED',
    'SEND_IN_PROGRESS',
    'SEND_OUTCOME_UNKNOWN',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const fieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=api-error.js.map